import { Address, Msg, Network, Signer, Simulation, TxResult } from "rujira.js";
import { Xumm } from "xumm";
import type { ResolvedFlow } from "xumm-oauth2-pkce";

export type XamanContext = ResolvedFlow;

export class XamanAdapter implements Signer {
  private xumm: Xumm;
  constructor(apiKey: string) {
    this.xumm = new Xumm(apiKey);
  }
  async connect(): Promise<Address[]> {
    const x = await this.xumm.authorize();
    if (x instanceof Error) throw x;
    if (!x) throw new Error(`No account returned`);
    return [x.me.account];
  }
  async simulate(msg: Msg): Promise<Simulation> {
    const inboundAddress = await msg.inboundAddress?.(msg.account.network);
    return {
      symbol: "XRP",
      decimals: 6,
      amount: inboundAddress?.gasRate || 0n,
      gas: inboundAddress?.gasRate || 0n,
    };
  }
  async signAndBroadcast(_simulation: Simulation, msg: Msg): Promise<TxResult> {
    if (!this.xumm.payload) throw new Error(`No xumm payload`);
    const payment = await msg.toXrpPayment();
    const { resolved, payload } = await this.xumm.payload.createAndSubscribe(
      payment,
      (x) => {
        if ("signed" in x.data) return x;
      }
    );

    await resolved;

    if (!payload.meta.signed) throw new Error("User Rejected Transaction");

    switch (payload.response.dispatched_result?.slice(0, 3)) {
      // Success
      case "tes":
        if (!payload.response.txid) throw new Error("No txid returned");
        return {
          network: "XRP",
          address: msg.account.address,
          txHash: payload.response.txid,
          deposited: msg.toDeposit?.(),
        };
      default:
        throw new Error(payload.response.dispatched_result || "Unknown Error");
    }
  }
  isAvailable() {
    return true;
  }
  disconnect() {
    this.xumm.logout();
  }
  onChange(cb: () => void) {
    this.xumm.on("success", cb);
  }
  public networks(): Network[] {
    return ["XRP"];
  }
}

const provider = new XamanAdapter(
  // Rujira public API key
  "9ce0c336-4724-47e6-8f35-21ce088226bf"
);
export default provider;
